/* eslint-disable react/prop-types */
import React from "react";
import Switch from "@material-ui/core/Switch";
import { Typography, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import CannibalizationDialogComponent from "./CannibalizationDialogComponent";

const useStyles = makeStyles(() => ({
  toggleContainer: {
    display: "flex",
    width: "100%",
    gap: "5px",
    alignItems: "center",
    justifyContent: "end",
  },
}));

export default function CannibalizationToggleComponent() {
  const classes = useStyles();
  const { selectedScenario } = useSelector((state) => state.scenarios);

  const [openDialog, setOpenDialog] = React.useState(false);

  const {
    scenario: { is_blocked: isBlocked },
  } = selectedScenario;
  const configCatSlice = useSelector((state) => state.auth.configCatUser);

  const handleSwitch = () => {
    setOpenDialog(!openDialog);
  };

  return (
    <>
      {configCatSlice?.features?.cannibalizationsOn && (
        <div className={classes.toggleContainer}>
          <Typography variant="body">
            {isBlocked
              ? "Remove scenario cannibalization"
              : "Cannibalize scenario"}
          </Typography>
          <Switch
            checked={isBlocked}
            onChange={handleSwitch}
            color="primary"
            name="cannibalize"
            inputProps={{ "aria-label": "cannibalization-switch" }}
          />
          <CannibalizationDialogComponent
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
          />
        </div>
      )}
    </>
  );
}
